import { Theme } from '@mui/material/styles';

export const badgeStyles = (theme: Theme) => ({
    '& .MuiBadge-badge': {
        backgroundColor: theme.palette.primary.light,
        padding: '6px',
        height: 'auto',
        borderRadius: '50%',
        bottom: '17%',
        right: '15%',
    },
});

export const avatarStyles = (theme: Theme) => ({
    width: 120,
    height: 120,
    backgroundColor: theme.palette.secondary.light,
});

export const avatarIconStyles = (theme: Theme) => ({
    fontSize: 32,
    color: theme.palette.divider,
});
